import { invoke } from '@shared/easyfy.decorators';
import '@clientWebModules/basket';
import '@clientWebModules/favourites';
import { addCss, removeCss, debounce } from '@shared/easyfy.utils';
import { isDesktop } from '@clientShared/utils';
import '@clientWebModules/breadcrumb';
import '@clientWebModules/menu';
import '@clientWebModules/countryselector';
import '@clientWebModules/mypagesbutton';
import '@clientWebModules/loginflyout';

@invoke
export default class Header {
  static Instance: Header;
  private pageTop: HTMLElement | null = document.querySelector('.page-top');
  private hasPromoBar: boolean = document.querySelector('.promo-bar') instanceof HTMLElement;
  private mainSection = document.querySelector('main');
  private promoBarHeight: number = this.hasPromoBar ? 40 : 0;
  private menuItemsWithChildren = document.querySelectorAll('[data-container="categories-section"] .menu-item.level-1.has-children') as NodeListOf<HTMLElement>;
  private menuItems = document.querySelectorAll('.menu-item.level-1') as NodeListOf<HTMLElement>;
  private timer: any;
  private isArrowNeededChecked: boolean = false;
  private headerHeight: number = 0;
  private pageTopObserver: IntersectionObserver | undefined;

  private debouncedUpdateHeaderStyle = debounce(() => {
    this.removeIntersectionObserver();
    this.setupIntersectionObservers();
  }, 200);

  onInit() {
    this.setupIntersectionObservers();

    window.addEventListener('resize', this.debouncedUpdateHeaderStyle);

    const mainSection = this.mainSection;
    if (isDesktop() && mainSection != null) {
      this.menuItemsWithChildren.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          this.timer = setTimeout(() => addCss(mainSection, 'menu-overlay'), 400);
        });
      });

      this.menuItemsWithChildren.forEach((item) => {
        item.addEventListener('mouseleave', () => {
          removeCss(mainSection, 'menu-overlay');
          clearTimeout(this.timer);
        });
      });
    }
  }

  setupIntersectionObservers() {
    if (!this.pageTop) {
      return;
    }
    if (!this.isArrowNeededChecked && this.isArrowNeeded()) {
      this.addArrow();
    }
    const observerOptions = isDesktop()
      ? {
          threshold: 0.0,
          rootMargin: `-80px 0px -80px 0px`,
        }
      : {
          threshold: 1.0,
          rootMargin: `${this.promoBarHeight}px 0px 0px 0px`,
        };
    // Measuring while sticky would read the collapsed fixed header, so only measure in the resting state.
    this.headerHeight = this.pageTop.offsetHeight;
    const headerMain = document.body.classList.contains('header-sticky') ? null : document.querySelector<HTMLElement>('.header-main');
    const headerMainHeight = headerMain?.offsetHeight;

    document.body.style.setProperty('--page-top-height', `${this.headerHeight}px`);
    if (headerMainHeight !== undefined) {
      // Used by .header-sticky styles to keep the header-main footprint (and the USP bar below it)
      // in place when header-main becomes position: fixed, so engaging sticky does not cause a layout shift.
      document.documentElement.style.setProperty('--header-main-height', `${headerMainHeight}px`);
    }
    this.pageTopObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.remove('header-sticky');
        }
        if (!entry.isIntersecting) {
          document.body.classList.add('header-sticky');
        }
      });
    }, observerOptions);
    this.pageTopObserver.observe(this.pageTop);
  }

  removeIntersectionObserver() {
    if (this.pageTopObserver && this.pageTop) {
      this.pageTopObserver.unobserve(this.pageTop);
      this.pageTopObserver.disconnect();
      this.pageTopObserver = undefined;
    }
  }

  addArrow() {
    const navArrow = document.querySelector('[data-scroll-direction="right"]');
    navArrow?.classList?.add('visible');
  }

  isArrowNeeded(): boolean {
    this.isArrowNeededChecked = true;
    const navList = document.querySelector('[data-container="nav-list"]') as HTMLElement;
    let totalWidthOfItemEls = 0;
    this.menuItems?.forEach((menuItem) => {
      const itemEl = menuItem;
      totalWidthOfItemEls += itemEl.offsetWidth;
    });

    if (totalWidthOfItemEls > navList?.offsetWidth) {
      return true;
    }

    return false;
  }
}
